export const DEFAULT_FILTER_TITLE = 'Любые даты';

export const DEFAULT_CALENDAR_TITLE = `${DEFAULT_FILTER_TITLE}, 1 чел.`;
